import { render } from "./MainMenuUser.vue?vue&type=template&id=b6e435e0&scoped=true"
import script from "./MainMenuUser.vue?vue&type=script&lang=js"
export * from "./MainMenuUser.vue?vue&type=script&lang=js"

import "./MainMenuUser.vue?vue&type=style&index=0&id=b6e435e0&scoped=true&lang=scss"
import "./MainMenuUser.vue?vue&type=style&index=1&id=b6e435e0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e435e0"]])

export default __exports__